import axios from "axios";
const API_URL = "/api/agent";

const list = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};

const findByNPN = (npn) => {
    return axios
      .get(API_URL, { params: { npn } })
      .then((response) => {
        if (response.data.length > 1) {
          throw new Error("Multiple agents found with NPN " + npn);
        };
        if (response.data.length === 0) {
          return null;
        }
        return response.data[0];
      });
  };

// #57 - principal-driven flows: the target agent's safe prefill (same shape as
// the agent's own session prefill) plus the missing-required-fields list.
const prefillFor = async (agentId) => {
  const response = await axios.get(`${API_URL}/${agentId}/prefill`);
  return response.data;
};

// #57 - principal fills a hierarchy agent's missing onboarding fields.
const updateProfileFor = async (agentId, values) => {
  const response = await axios.put(`${API_URL}/${agentId}/profile`, values);
  return response.data;
};

const importAgents = async (formData) => {
  const response = await axios.postForm(API_URL, formData);
  return response;
};

// #9/#10 — the authenticated agent saves their own licensed states (writes only
// their own record on the server). Called once from the first flow screen.
const updateLicensedStates = async (licensedStates) => {
  const response = await axios.put(API_URL + "/me/licensed-states", {
    licensedStates,
  });
  return response.data;
};

// #29 — the authenticated agent completes the one-time onboarding step (writes
// only their own record on the server). Returns { onboardingCompletedAt }.
const updateProfile = async (profile) => {
  const response = await axios.put(API_URL + "/me/profile", profile);
  return response.data;
};

// #2 — answer the "Is this you?" signup-match prompt. confirmed:true links the
// account as an existing agent; false unlinks and routes to support.
const confirmMatch = async (confirmed) => {
  const response = await axios.put(API_URL + "/me/confirm-match", { confirmed });
  return response.data;
};

const AgentService = {
  prefillFor,
  updateProfileFor,
  list,
  importAgents,
  findByNPN,
  updateLicensedStates,
  updateProfile,
  confirmMatch,
};

export default AgentService;
